"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fieldTypesWithOptionsPanel = exports.fieldTypesWithDefaultValue = exports.fieldTypesWithPlaceholder = exports.FieldTypeNames = exports.SpecialFieldTypes = exports.FieldTypes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _keyMirror4 = _interopRequireDefault(require("react-utils/keyMirror"));

var _keyMirror, _keyMirror2, _keyMirror3;

var FieldTypes = {
  TEXT: 'text',
  CHECKBOX: 'checkbox',
  SINGLE_CHECKBOX: 'booleancheckbox',
  RADIO: 'radio',
  SELECT: 'select',
  DATE: 'date',
  TEXTAREA: 'textarea',
  NUMBER: 'number',
  FILE: 'file',
  PHONE: 'phone',
  SUBMIT: 'submit'
};
exports.FieldTypes = FieldTypes;
var SpecialFieldTypes = {
  RICH_TEXT: 'richtext__hubspot_private',
  CAPTCHA: 'captcha__hubspot_private'
};
exports.SpecialFieldTypes = SpecialFieldTypes;
var FieldTypeNames = Object.values(FieldTypes || {});
exports.FieldTypeNames = FieldTypeNames;
var fieldTypesWithPlaceholder = (0, _keyMirror4.default)((_keyMirror = {}, (0, _defineProperty2.default)(_keyMirror, FieldTypes.TEXT, null), (0, _defineProperty2.default)(_keyMirror, FieldTypes.TEXTAREA, null), (0, _defineProperty2.default)(_keyMirror, FieldTypes.NUMBER, null), (0, _defineProperty2.default)(_keyMirror, FieldTypes.SELECT, null), _keyMirror));
exports.fieldTypesWithPlaceholder = fieldTypesWithPlaceholder;
var fieldTypesWithDefaultValue = (0, _keyMirror4.default)((_keyMirror2 = {}, (0, _defineProperty2.default)(_keyMirror2, FieldTypes.TEXT, null), (0, _defineProperty2.default)(_keyMirror2, FieldTypes.TEXTAREA, null), (0, _defineProperty2.default)(_keyMirror2, FieldTypes.DATE, null), (0, _defineProperty2.default)(_keyMirror2, FieldTypes.NUMBER, null), _keyMirror2));
exports.fieldTypesWithDefaultValue = fieldTypesWithDefaultValue;
var fieldTypesWithOptionsPanel = (0, _keyMirror4.default)((_keyMirror3 = {}, (0, _defineProperty2.default)(_keyMirror3, FieldTypes.SELECT, null), (0, _defineProperty2.default)(_keyMirror3, FieldTypes.RADIO, null), (0, _defineProperty2.default)(_keyMirror3, FieldTypes.CHECKBOX, null), _keyMirror3));
exports.fieldTypesWithOptionsPanel = fieldTypesWithOptionsPanel;